/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { setTimeShow, handleNextStep, handleStepBack, sendAddressChangeCallback, setFNOLLocation, setStep } from '../../../actions/claimSubmitActions';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import Geocode from "react-geocode";
import { isMobile } from 'react-device-detect';
import PlacesAutocomplete, { geocodeByAddress, getLatLng, } from 'react-places-autocomplete';
import '../../FNOL/FNOL.css'
import { FNOL_CLAIM_PROGRESS_MOBILE } from '../../../routes/routes';
import { navigateTo } from '../../../actions/navigationActions';
import KPDropdown from '../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import { IDropdownData } from '../../../interfaces/KPDropdown/KPDropdownInterfaces';
import { logErrorToDatabase, postToController } from '../../../actions/apiActions';
import { CAR_NIGHT_PARKING_LOCATION_ID, CLAIM_OCCURANCE_AT_HOME, CLAIM_OCCURANCE_AWAY_FROM_HOME, INCIDENT_LOCATION_ID, SET_CLAIM_DATA } from '../../../constants/constants';

const atHome = 2
const awayFromHome = 1

class FnolStep2Sub1 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {
            DescriptionWhereSubmitted: this.props.claimSubmit.whereDescription !== "",
            addressSelect: this.props.claimSubmit.address,
            addressDetail: this.props.claimSubmit.addressDetail,
            lat: this.props.claimSubmit.addressLat,
            lng: this.props.claimSubmit.addressLon,
            incidentDescriptionWhere: this.props.claimSubmit.whereDescription,
            whereItHappenedList: [
                { id: atHome, description: "The incident occured at home (your premises)" },
                { id: awayFromHome, description: "The incident occured away from home" }
            ],
            selectedWhereItHappened: "",
            locationList: [],
            selectedLocation: "",
        }
        this.handleChangeDescriptionWhere = this.handleChangeDescriptionWhere.bind(this);
        this.handleChangeLocationSelection = this.handleChangeLocationSelection.bind(this);
        this.checkSubmitDescriptionWhere = this.checkSubmitDescriptionWhere.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleStepBack = this.handleStepBack.bind(this);
        this.mapReady = this.mapReady.bind(this);
        this.mapClick = this.mapClick.bind(this);
        this.setLocation = this.setLocation.bind(this);
        this.handleAddressSelect = this.handleAddressSelect.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.checkMobileRedirect = this.checkMobileRedirect.bind(this);
    }

    componentDidMount = () => {
        window.scrollTo(0, 0);
        Geocode.setApiKey("AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8");
    }

    handleAddressChange = address => {
        this.setState({ addressSelect: address });
        this.checkSubmitDescriptionWhere();
    };

    handleAddressSelect = address => {
        geocodeByAddress(address)
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                this.setLocation(latLng.lat, latLng.lng, address);
                this.checkSubmitDescriptionWhere();
            })
            .catch((err) => { logErrorToDatabase("Error retrieving geoCode by Address: " + address + ": " + err) });
    };

    async handleSubmit(e: any) {
        await this.setState({ DescriptionWhereSubmitted: true })
        await this.checkSubmitDescriptionWhere();
        if (!this.state.DescriptionWhereDisabled) {
            await this.setState({ currentStep: 3 });
            await this.props.dispatchHandleNextStep();
            this.checkMobileRedirect();
            if (this.state.selectedLocation !== "" && this.state.selectedLocation?.description.toLowerCase() === "address not listed") {
                await this.props.dispatchAction(sendAddressChangeCallback())
            }
        }
        else {
            this.setState({ DescriptionWhereDisabled: true })
        }
        this.setState({ DescriptionWhereSubmitted: true })
    }

    async checkMobileRedirect() {
        if (isMobile && (this.props.claimSubmit.lastCompletedStep > (this.props.claimSubmit.selectedClaimStep.step))) {
            await this.props.redirectTo(FNOL_CLAIM_PROGRESS_MOBILE);
            await this.props.dispatchSetStep(this.props.claimSubmit.lastCompletedStep, this.props.claimSubmit.lastCompletedSubStep);
            await this.props.dispatchHandleNextStep();
        }
    }

    async handleStepBack() {
        this.setState({ DescriptionWhatDisabled: false });
        await this.props.dispatchHandleStepBack();
    }

    async mapReady(mapProps, map) {
        let lat: any = map.center.lat();
        let lng: any = map.center.lng();

        if (window.navigator && window.navigator.geolocation) {
            let location = window.navigator.geolocation;
            if (location) {
                location.getCurrentPosition((position) => {
                    lat = position.coords.latitude;
                    lng = position.coords.longitude;
                    this.setLocation(lat, lng, "");
                });
            }
        }
    }

    async mapClick(mapProps, map, clickEvent) {
        let lat = clickEvent.latLng.toJSON().lat
        let lng = clickEvent.latLng.toJSON().lng
        this.setLocation(lat, lng);
    }

    async setLocation(lat, lng, addressSelection: any = null) {
        let address, streetNumber, streetName, suburb, city, state, country, postal_code;

        await Geocode.fromLatLng(lat, lng).then(
            async (response) => {
                let bestAddress: any = null;
                for (let r = 0; r < response.results.length; r++) {
                    if (response.results[r].address_components.length > (bestAddress?.address_components.length ?? 0)) {
                        bestAddress = response.results[r];
                        address = response.results[r].formatted_address;
                    }
                }

                for (let i = 0; i < bestAddress.address_components.length; i++) {
                    for (let j = 0; j < bestAddress.address_components[i].types.length; j++) {
                        switch (bestAddress.address_components[i].types[j]) {
                            case "street_number":
                                streetNumber = bestAddress.address_components[i].long_name;
                                break;
                            case "route":
                                streetName = bestAddress.address_components[i].long_name;
                                break;
                            case "sublocality":
                                suburb = bestAddress.address_components[i].long_name;
                                break;
                            case "locality":
                                city = bestAddress.address_components[i].long_name;
                                break;
                            case "administrative_area_level_1":
                                state = bestAddress.address_components[i].long_name;
                                break;
                            case "country":
                                country = bestAddress.address_components[i].long_name;
                                break;
                            case "postal_code":
                                postal_code = bestAddress.address_components[i].long_name;
                                break;
                        }
                    }
                }
            }
        );

        if (addressSelection !== null) {
            address = addressSelection;
        }

        let formatted: any = address;
        if (streetName?.length > 0 && streetNumber?.length > 0) {
            formatted = formatted.replace(`, ${suburb}`, "");
        }
        formatted = formatted.replace(`, ${city}`, "").replace(`, ${state}`, "").replace(`, ${country}`, "").replace(`, ${postal_code}`, "");

        this.setState({ lat: lat, lng: lng, addressSelect: address, addressDetail: { province: state?.toUpperCase(), city: city?.toUpperCase(), suburb: suburb?.toUpperCase(), formatted, postalCode: postal_code?.toUpperCase()} });
    }

    handleChangeDescriptionWhere(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
        this.checkSubmitDescriptionWhere();
    }

    async handleChangeLocationSelection(e: any) {
        let selectedItem = this.state.whereItHappenedList.filter(function (item) {
            return item.id == e;
        })

        await this.setState({ selectedWhereItHappened: selectedItem[0], selectedLocation: "", locationList: [], addressSelect: "", addressDetail:"" });
        if (selectedItem[0].id === atHome) {
            await postToController(this.props.dispatch, 'GetRiskItemParkingAddressList',
                JSON.stringify({ Parameter: this.props.claimSubmit.selectedRiskItem.id })).then(async (response) => {
                    await this.setState({ selectedWhereItHappened: selectedItem[0], locationList: response });
                })
        }
        this.checkSubmitDescriptionWhere();
    }

    async handleChangeAddressSelection(e: any) {
        let selectedItem = this.state.locationList.filter(function (item) {
            return item.id == e;
        })
        await this.setState({ selectedLocation: selectedItem[0] });
        this.checkSubmitDescriptionWhere();
    }

    async checkSubmitDescriptionWhere() {
        let payloadToUse = {}
        if (this.state.selectedWhereItHappened) {
            if (this.state.selectedWhereItHappened.id === awayFromHome) {
                if (this.state.incidentDescriptionWhere && this.state.addressSelect !== "") {
                    this.setState({ DescriptionWhereDisabled: false });
                    payloadToUse = {
                        whereDescription: this.state.incidentDescriptionWhere,
                        address: this.state.addressSelect,
                        addressLat: this.state.lat,
                        addressLon: this.state.lng,
                        lat: this.state.lat,
                        lon: this.state.lng,
                        addressDetail: this.state.addressDetail,
                        riskItemParkingAddress: "",
                        claimParkingLocationId: INCIDENT_LOCATION_ID,
                        claimOccuranceLocation: CLAIM_OCCURANCE_AWAY_FROM_HOME
                    };
                } else {
                    this.setState({ DescriptionWhereDisabled: true });
                }
            }
            else if (this.state.selectedWhereItHappened.id === atHome && this.state.selectedLocation !== "") {
                if (this.state.selectedLocation?.description.toLowerCase() === "address not listed") {
                    if (this.state.addressSelect) {
                        this.setState({ DescriptionWhereDisabled: false });
                        payloadToUse = {
                            address: this.state.addressSelect,
                            addressLat: this.state.lat,
                            addressLon: this.state.lng,
                            lat: this.state.lat,
                            lon: this.state.lng,
                            addressDetail: this.state.addressDetail,
                            riskItemParkingAddress: "",
                            claimParkingLocationId: CAR_NIGHT_PARKING_LOCATION_ID,
                            claimOccuranceLocation: CLAIM_OCCURANCE_AT_HOME,
                        };
                    } else {
                        this.setState({ DescriptionWhereDisabled: true });
                    }
                }
                else {
                    this.setState({ DescriptionWhereDisabled: false });
                    payloadToUse = {
                        riskItemParkingAddress: this.state.selectedLocation.id,
                        address: this.state.selectedLocation.description,
                        addressLat: this.state.selectedLocation.latitude,
                        addressLon: this.state.selectedLocation.longitude,
                        lat: this.state.lat,
                        lon: this.state.lng,
                        addressDetail: { province: this.state.selectedLocation.province?.toUpperCase(), city: this.state.selectedLocation.city?.toUpperCase(), suburb: this.state.selectedLocation.suburb?.toUpperCase(), formatted: this.state.selectedLocation.description?.toUpperCase(), postalCode:  this.state.selectedLocation.postalCode?.toUpperCase()},
                        claimParkingLocationId: CAR_NIGHT_PARKING_LOCATION_ID,
                        claimOccuranceLocation: CLAIM_OCCURANCE_AT_HOME,
                    };
                }
            }
            else if (this.state.selectedWhereItHappened.id === atHome && this.state.selectedLocation === "") {
                this.setState({ DescriptionWhereDisabled: true });
            }
            this.props.dispatchAction({
                type: SET_CLAIM_DATA, payload: payloadToUse
            })
        }
        else {
            this.setState({ DescriptionWhereDisabled: true });
        }
    }

    public render() {
        let whereSelection = this.state.whereItHappenedList
            .map(item => {
                return ({
                    description: item.description,
                    id: item.id,
                    image: "",
                    productName: ""
                }) as IDropdownData;
            });

        let locationSelection: IDropdownData = {
            id: "",
            description: "",
            image: "",
            productName: "",
        }
        if (this.state.locationList.length > 0) {
            locationSelection = this.state.locationList
                .map(item => {
                    return ({
                        description: item.description,
                        id: item.id,
                        image: "",
                        productName: ""
                    }) as IDropdownData;
                });
        }
        const countryFilter = this.props.profile.countryId === 244 ? "ZA" : "NA"
        let googleMap = <div id="GoogleMap">
            <p>Super important step: Please share the Google Maps location</p>
            <div>
                <PlacesAutocomplete
                    value={this.state.addressSelect}
                    onChange={this.handleAddressChange}
                    onSelect={this.handleAddressSelect}
                    searchOptions={{ componentRestrictions: { country: countryFilter } }}
                >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div className="position-relative">
                            <input
                                {...getInputProps({
                                    placeholder: 'Find location',
                                    className: ' ssp-autocomplete-searchbox',
                                })}
                            />
                            <div className={(suggestions.length > 0 ? 'ssp-autocomplete-dropdown-container' : 'd-none')}>
                                {loading && <div className="ssp-autocomplete-loading">Loading...</div>}
                                {suggestions.map(suggestion => {
                                    const className = 'ssp-autocomplete-suggestion-item';
                                    return (
                                        <>
                                            <div
                                                {...getSuggestionItemProps(suggestion, {
                                                    className,
                                                })}
                                            >
                                                <span className="ssp-autocomplete-suggestion-actual">{suggestion.description}</span>
                                            </div>
                                            <div className="ssp-autocomplete-hr-container">
                                                <hr className="ssp-autocomplete-hr-divider" />
                                            </div>
                                        </>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </PlacesAutocomplete>
            </div>
            {this.state.DescriptionWhereSubmitted && this.state.addressSelect === "" &&
                <div className="form-inline-error">Location of where it happened is required</div>
            }
            <div className="ssp-googlemap-holder">
                <Map google={this.props.google}
                    centerAroundCurrentLocation
                    center={{ lat: this.state.lat, lng: this.state.lng }}
                    onReady={this.mapReady}
                    onClick={this.mapClick}
                    containerStyle={{
                        position: 'relative',
                        overflow: 'hidden',
                        width: '100%',
                        height: '100%',
                        borderRadius: '8px'
                    }}>
                    <Marker
                        // @ts-ignore
                        position={{ lat: this.state.lat, lng: this.state.lng }}
                        draggable={false}
                        title="Accident location"
                    />
                </Map>
            </div>
        </div>
        return (<div id="SubmitClaim" className="col ssp-container-fnol-where-it-happened ssp-container-fnol-step-header-padding ssp-form">
            <div className="row noma">
                <div className="col-12 nopa ssp-header-fnol-where-it-happened">
                    <div className="row noma">
                        <div className="fnol-step-header-icon-area">
                            <img src='/my-policy/Images/Claims/Numbers/number-2-red-32x32px.svg' alt="Step 2" title="Step 2" />
                        </div>
                        <div className="col fnol-step-header-title-area">
                            <h3>Tell us where it happened</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row noma">
                <div className="col-12 fnol-steps-form-section-holder">
                    <hr className="hr-minus21px" />
                    <div className="col-12 mb-20px nopa">
                        <p className="font-weight-normal line-height-normal mb-0px">Select where the incident occurred</p>
                    </div>
                    <div className="col-12 nopa fnol-product-type-selector-holder">
                        <KPDropdown
                            id={"WhereItHappened-fnol"}
                            isImageDropdown={false}
                            showLabelAfterSelection={true}
                            showLabelInside={true}
                            showLabelOutside={false}
                            isRiskItem={false}
                            label={"Location of incident"}
                            title={"Location of incident"}
                            data={whereSelection}
                            handleSelection={(e) => this.handleChangeLocationSelection(e)}
                            selectedValue={this.state.selectedWhereItHappened}
                        />
                    </div>
                    {this.state.selectedWhereItHappened && this.state.selectedWhereItHappened.id === awayFromHome &&
                        <>
                            <p className="fnol-where-it-happened-intro-p mt-25px">Where did this incident take place (share as much info as possible) </p>
                            <div className={'form-group ' + (this.state.DescriptionWhereSubmitted && !this.state.incidentDescriptionWhere ? ' has-error' : '')}>
                                <textarea id="incidentDescriptionWhere" name="incidentDescriptionWhere" rows={4} cols={50} className="ssp-form-textarea" placeholder="Tap here to start typing" value={this.state.incidentDescriptionWhere} onChange={this.handleChangeDescriptionWhere} />
                                {this.state.DescriptionWhereSubmitted && !this.state.incidentDescriptionWhere &&
                                    <div className="form-inline-error">Description of where it happened is required</div>
                                }
                            </div>
                            {googleMap}
                        </>
                    }
                    {this.state.selectedWhereItHappened.id === atHome && locationSelection &&
                        <div className="mt-20px">
                            <KPDropdown
                                id={"WhereItHappenedLocation-fnol"}
                                isImageDropdown={false}
                                showLabelAfterSelection={true}
                                showLabelInside={true}
                                showLabelOutside={false}
                                isRiskItem={false}
                                label={"Select address"}
                                title={"Select address"}
                                data={locationSelection}
                                handleSelection={(e) => this.handleChangeAddressSelection(e)}
                                selectedValue={this.state.selectedLocation}
                            />
                            {this.state.selectedLocation && this.state.selectedLocation?.description.toLowerCase() === "address not listed" &&
                                <>
                                    {googleMap}
                                </>
                            }
                        </div>
                    }
                    <div className="col-12 nopa fnol-where-it-happened-buttonholder">
                        <button className="btn btn-solid-red fnol-where-it-happened-button-next" disabled={this.state.DescriptionWhereDisabled} onClick={this.handleSubmit}>Next</button>
                        <button className="btn btn-outline-red fnol-where-it-happened-button-back" onClick={this.handleStepBack}>Back</button>
                    </div>
                </div>
            </div>
        </div>)
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {

        dispatchSetTimeShow: () => dispatch(setTimeShow()),
        dispatchSetStep: (step, subStep) => dispatch(setStep(step, subStep)),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchSetFNOLLocation: (WhereDescription, Address, AddressLat, AddressLon) => dispatch(setFNOLLocation(WhereDescription, Address, AddressLat, AddressLon)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchAction: (e) => dispatch(e),
    }
}
const connector = connect(mapStateToProps, mapDispatchToProps)(FnolStep2Sub1);

export default GoogleApiWrapper({
    apiKey: 'AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8'
})(connector);